/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteNoveltyPricesRequest
 */
export interface DeleteNoveltyPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof DeleteNoveltyPricesRequest
     */
    priceUnitId: number;
}

/**
 * Check if a given object implements the DeleteNoveltyPricesRequest interface.
 */
export function instanceOfDeleteNoveltyPricesRequest(value: object): value is DeleteNoveltyPricesRequest {
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    return true;
}

export function DeleteNoveltyPricesRequestFromJSON(json: any): DeleteNoveltyPricesRequest {
    return DeleteNoveltyPricesRequestFromJSONTyped(json, false);
}

export function DeleteNoveltyPricesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteNoveltyPricesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'priceUnitId': json['priceUnitId'],
    };
}

export function DeleteNoveltyPricesRequestToJSON(json: any): DeleteNoveltyPricesRequest {
    return DeleteNoveltyPricesRequestToJSONTyped(json, false);
}

export function DeleteNoveltyPricesRequestToJSONTyped(value?: DeleteNoveltyPricesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceUnitId': value['priceUnitId'],
    };
}

